var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearchSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000099648788898145162260000002703726279675105692_);}\r\n\t.st1{fill:#27395F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031199091191875799300000012233039661248166044_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10",
    style: {
      clipPath: "url(#SVGID_00000031199091191875799300000012233039661248166044_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    className: "st1",
    d: "M20,4.44v13.33C20,19,19,20,17.78,20H2.22c-0.59,0.01-1.16-0.23-1.57-0.65 C0.23,18.94-0.01,18.37,0,17.78V2.22c-0.01-0.59,0.23-1.16,0.65-1.57C1.06,0.23,1.63-0.01,2.22,0h13.33L20,4.44z M17.78,5.39 l-3.17-3.17H2.22v15.56h15.56V5.39z M10,16.67c1.83,0.01,3.33-1.47,3.33-3.3c0-0.01,0-0.02,0-0.03c0.01-1.83-1.47-3.33-3.3-3.33 c-0.01,0-0.02,0-0.03,0c-1.83-0.01-3.33,1.47-3.33,3.3c0,0.01,0,0.02,0,0.03c-0.01,1.83,1.47,3.33,3.3,3.33 C9.98,16.67,9.99,16.67,10,16.67 M3.33,7.78h10V3.33h-10L3.33,7.78z M2.22,5.39L2.22,5.39z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchSave);
export default __webpack_public_path__ + "static/media/ico_search_save.1b437ce9e972e2689b1b0c46d997ecc6.svg";
export { ForwardRef as ReactComponent };